module.exports = __webpack_public_path__ + "fonts/s2-icons.3f3c48a.ttf";